import * as api from '../../services/smsConfig'

export const FETCH_SMSFILTERS= 'FETCH_SMSFILTERS';



export const fetchSmsFilters = (params, pagination, sort, extra) => {

    return {
        type: FETCH_SMSFILTERS,
        payload: {
            promise: api.findSmsfilters(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/smsConfig.js